const global = {
  'your-queues': 'Your queues',
  'your-visits': 'Your slots',
  'back-to-prev-page': 'Back to previous page',
  'admin-panel': 'Administration panel',
  'cancel': 'Cancel',
  'confirm': 'Confirm',
  'confirmation': 'Confirmation',
  'expand-menu': 'Expand menu',
  'collapse-menu': 'Collapse menu',
  'no-result': 'No results',
  'loading': 'Loading ...',
  'refresh': 'Refresh',
  'search': 'Szukaj',
  'forbidden': 'Forbidden!',
  unknownError: 'Unknown Error!'
};

export default global;
